/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SuggestionDtoBase
 * auto generated base class for the model SuggestionDtoModel.
 */
export const SuggestionDtoModelBase = ModelBase
  .named('SuggestionDto')
  .props({
    __typename: types.optional(types.literal("SuggestionDto"), "SuggestionDto"),
    id: types.identifier,
    address: types.union(types.undefined, types.string),
    latitude: types.union(types.undefined, types.number),
    longitude: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SuggestionDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get address() { return this.__attr(`address`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
}
export function selectFromSuggestionDto() {
  return new SuggestionDtoModelSelector()
}

export const suggestionDtoModelPrimitives = selectFromSuggestionDto().address.latitude.longitude
